@if(loadingState) {
  <app-bm-loading-state/>
} @else {
  @if(selectorData && budgetForm) {
    <div class="flex flex-col gap-[1.25rem]">
      <app-header-budget-model
        class="main"
        [ngClass]="budgetForm.controls.isEditState.value ? '' : 'h-[4.75rem]'"
        [budgetForm]="budgetForm"
        [selectorData]="selectorData"
        (modelSelectedEmitter)="changeModel($event)"
        (buttonClickEmitter)="buttonClicked($event)"
        (exportExcelEmitter)="exportExcel()">
      </app-header-budget-model>
      <app-table-budget-model class="main" [budgetForm]="budgetForm"/>
      <app-bm-analytics [budgetForm]="budgetForm"/>
    </div>
  }
}


